import { render, staticRenderFns } from "./PayPanel.vue?vue&type=template&id=897ba5cc&scoped=true&"
import script from "./PayPanel.vue?vue&type=script&lang=js&"
export * from "./PayPanel.vue?vue&type=script&lang=js&"
import style0 from "./PayPanel.vue?vue&type=style&index=0&id=897ba5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897ba5cc",
  null
  
)

export default component.exports